<script>
/**
 * Topbar component
 */
export default {
  data () {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/china.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: this.$i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  mounted () {
    this.value = this.languages.find((x) => x.language === this.$i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu () {
      this.$parent.toggleMenu();
    },
    /**
     * Full screen
     */
    initFullScreen () {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    /**
     * Toggle rightbar
     */
    toggleRightSidebar () {
      this.$parent.toggleRightSidebar();
    },
    /**
     * Set languages
     */
    setLanguage (locale, country, flag) {
      this.$i18n.locale = locale;
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
    },
    /**
     * Horizontal-toggle menu
     */
    horizonalmenu () {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },

    async logOut () {
      if (!confirm("確認要登出嗎？")) {
        return
      }

      try {
        // 調用後端登出 API
        await this.$root.apis.logout((response) => {
          // 登出成功
          if (response.body.success) {
            console.log("登出成功")
          }
        }, (error) => {
          console.error("登出錯誤:", error)
          // 即使登出 API 失敗，也清除本地資料
        })
      } catch (error) {
        console.error("登出異常:", error)
      } finally {
        // 清除本地資料（無論 API 是否成功）
        if (this.$root.common) {
          this.$root.common.setCookie("api-token", "")
          this.$root.common.setCookie("user", "")
          this.$root.common.setCookie("login", "")
        }
        this.$root.login = false
        
        // 跳轉到登入頁
        if (this.$router) {
          this.$router.push("/login")
        }
      }
    }
  },
};
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <div class="container-fluid">
      <ul class="list-unstyled topnav-menu float-right mb-0">
        <b-nav-item-dropdown right class="notification-list topbar-dropdown" menu-class="profile-dropdown"
          toggle-class="p-0">
          <template slot="button-content" class="nav-link dropdown-toggle">
            <div class="nav-user mr-0">
              <img src="@/assets/images/users/avatar-1.jpg" alt="user-image" class="rounded-circle" />
              <span class="pro-user-name ml-1">
                {{ $t("navbar.dropdown.name.text") }}
                <i class="mdi mdi-chevron-down"></i>
              </span>
            </div>
          </template>

          <!-- <b-dropdown-header>
            <h6 class="text-overflow m-0 py-2">
              {{ $t("navbar.dropdown.name.list.greet") }}
            </h6>
          </b-dropdown-header> -->

          <b-dropdown-divider></b-dropdown-divider>
          <a class="dropdown-item" @click="logOut">
            <i class="fe-log-out mr-1"></i>
            <span>登出</span>
          </a>
        </b-nav-item-dropdown>
      </ul>

      <!-- LOGO -->
      <div class="logo-box">
        <router-link to="/" class="logo logo-dark text-center">
          <span class="logo-sm">
            <!-- <img src="@/assets/images/logo-sm-dark.png" alt height="24" /> -->
            <span class="logo-lg-text-light">Minton</span>
          </span>
          <span class="logo-lg">
            <!-- <img src="@/assets/images/logo-dark.png" alt height="20" /> -->
            <span class="logo-lg-text-light">M</span>
          </span>
        </router-link>
      </div>

      <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
        <li>
          <button class="button-menu-mobile waves-effect waves-light" @click="toggleMenu">
            <i class="fe-menu"></i>
          </button>
        </li>

        <li>
          <!-- Mobile menu toggle (Horizontal Layout)-->
          <a class="navbar-toggle nav-link" data-toggle="collapse" @click="horizonalmenu()"
            data-target="#topnav-menu-content">
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
          <!-- End mobile menu toggle-->
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
  </div>
  <!-- end Topbar -->
</template>
